import agent, { prepareHeaders } from 'api/agent';

export const CoolBox = {
    RequestOpeningCoolBox: (name: string) =>
        agent.requests.post(`/CoolBox/${name}/open`, prepareHeaders()),
};
